import arrowRight from '../../assets/icons/arrow_right.png'
import ourMison from '../../assets/OurMission/our-mission-header.png'
import OurValues from './OurValues'
import { useNavigate } from 'react-router-dom'
const OurMissionHeader = () => {
  const navigate = useNavigate()
  return (
    <div className='w-full px-5 lg:px-7 box-border flex justify-between flex-wrap relative lg:static '>
      <div className='flex flex-col items-start w-[273px] lg:w-[379px] 2xl:w-[516px] 2xl:gap-5   3xl:w-[719px] mt-[40px] lg:mt-[80px] 2xl:mt-[180px]'>
        <div className='flex items-start gap-5 lg:gap-6 2xl:gap-8 2xl:self-strech 3xl:gap-10 3xl:self-auto'>
          <div className='w-1 h-[1200px] lg:h-[900px] 2xl:w-2 2xl:h-[1100px] 3xl:h-[1500px] bg-[linear-gradient(90deg,_#3DC3D8_0%,_#24547C_100%)]'></div>

          <div className='flex flex-col items-start gap-10 w-[270px] lg:w-[347px] lg:gap-20 2xl:gap-[120px] 2xl:flex-[1_0_0] 3xl:w-[680px] 3xl:gap-40'>
            <div className='flex w-full flex-col gap-4 lg:gap-6 2xl:gap-12'>
              <h1 className='text-2xl font-bold text-[#020251] leading-8 tracking-wide lg:text-3xl lg:leading-none lg:tracking-normal 2xl:text-[40px]  3xl:text-[64px]'>
                Find a lawyer {''}
                <span className='text-[#65C2D7]'>ready to help you.</span>
              </h1>

              <p className='text-xs font-normal text-[#586885] leading-4 tracking-wide text-justify lg:text-sm lg:leading-5 2xl:text-lg 2xl:leading-6 3xl:text-2xl 3xl:leading-8'>
                Where do people start looking for help when they are faced with
                a legal problem?
              </p>
              <p className='text-xs font-normal text-[#586885] leading-4 tracking-wide text-justify lg:text-sm lg:leading-5 2xl:text-lg 2xl:leading-6 3xl:text-2xl 3xl:leading-8'>
                Legal Utopia finds the lawyer they need quickly and easily at a
                price they can afford.
              </p>
            </div>

            <div className='lg:hidden relative w-[300.432px] h-[272.765px] shrink-0'>
              <div className='shrink-0 rounded-[40px] bg-[#0C5F71] w-[233.799px] h-[233.799px] box-border absolute top-0  z-10'></div>
              <div className='shrink-0 rounded-[40px] border-[2px] border-[#8DD8EB] w-[233.799px] h-[233.799px]   absolute right-0  z-30'></div>

              <img
                src={ourMison}
                className='absolute bottom-0 left-0  w-[233.799px] h-[233.799px]  z-20 '
              />
            </div>
            <button
              className='flex lg:hidden justify-center items-center shrink-0 w-[200px] h-8 px-[12px] py-1.5 rounded-[6px] text-white text-center text-base font-medium leading-5 tracking-wide bg-[#020251] shadow-[0px_1px_4px_rgba(0,0,0,0.25)] 
                 hover:text-[#65C2D7] mt-[20px] lg:none '
            >
              Get a help today
            </button>
            <div className='flex flex-col  gap-10 w-[273px]  self-stretch lg:w-full lg:gap-10 2xl:gap-20 3xl:gap-30'>
              <div className='flex items-start self-stretch gap-3 2xl:gap-4 3xl:gap-6'>
                <img
                  src={arrowRight}
                  className='w-4 h-4 2xl:h-6 2xl:w-6 block mt-[6px]'
                />
                <div className='flex flex-col items-start gap-3 2xl:gap-4 3xl:gap-6'>
                  <h3 className='text-sm font-medium text-[#001A3D] lg:text-base lg:leading-6 2xl:text-lg 2xl:font-bold 2xl:leading-6  3xl:text-2xl 3xl:leading-8 '>
                    To take the stress, time and risk out of finding the right
                    lawyer.
                  </h3>
                  <p className='text-xs font-normal text-[#37A2BA]  leading-4 tracking-wide  lg:text-sm lg:leading-5 text-[#586885] 2xl:text-lg 2xl:leading-6 3xl:text-2xl 3xl:leading-8'>
                    Our mission is to be the most
                    <span className='text-[#37A2BA] 3xl:font-bold'>
                      &nbsp; accurate and reliable source&nbsp;
                    </span>
                    of information about legal professionals and help people
                    <span className='text-[#37A2BA] 3xl:font-bold'>
                      &nbsp; make informed choices&nbsp;
                    </span>
                    when they are looking for a lawyer. Our customers can be
                    certain that all the lawyers listed on our platform are
                    &nbsp;
                    <span className='text-[#37A2BA] 3xl:font-bold'>
                      qualified, reputable, and matched to their needs.
                    </span>
                  </p>
                </div>
              </div>
              <div className='flex items-start self-stretch gap-3 2xl:gap-4 3xl:gap-6'>
                <img
                  src={arrowRight}
                  className='w-4 h-4 2xl:h-6 2xl:w-6 block mt-[6px]'
                />

                <div className='flex flex-col items-start gap-3 2xl:gap-4 3xl:gap-6'>
                  <h3 className='text-sm font-medium text-[#001A3D] lg:text-base lg:leading-6 2xl:text-lg 2xl:font-bold 2xl:leading-6  3xl:text-2xl 3xl:leading-8 '>
                    How do we do this
                  </h3>
                  <p className='text-xs font-normal text-[#37A2BA]  leading-4 tracking-wide  lg:text-sm lg:leading-5 text-[#586885] 2xl:text-lg 2xl:leading-6 3xl:text-2xl 3xl:leading-8'>
                    By making sure we understand people’s legal needs and
                    leveraging our data to match them with the right lawyer.
                    Find a Lawyer brings together{' '}
                    <span className='text-[#37A2BA] 3xl:font-bold'>
                      &nbsp; the very latest market data &nbsp;
                    </span>
                    with Legal Utopia’s proprietary technology to surface only
                    the information and lawyer profiles that meet your
                    requirements. Underpinning this is our ongoing work
                    collating dozens of public and private data sets into one
                    place so that our customers can extract the information they
                    need and know that it is reliable, relevant and up to date.
                    Our systems enable us to provide{' '}
                    <span className='text-[#37A2BA] 3xl:font-bold'>
                      &nbsp;the most effective data intelligence
                    </span>
                    &nbsp; for
                    <span className='text-[#37A2BA] 3xl:font-bold'>
                      &nbsp; the best decisions. 
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className='lg:hidden absolute top-0 right-[50px] flex-shrink-0 w-[2px] h-[639px]
          bg-[linear-gradient(90deg,_#3DC3D8_0%,_#24547C_100%)]'
          ></div>
        </div>
        <h3 className='text-[#65C2D7]  font-bold text-lg leading-6 mt-3 tracking-wide lg:text-2xl lg:leading-8 2xl:text-[32px] 3xl:text-[40px]'>
          Trust Legal Utopia to find you the right lawyer, every time.
        </h3>
      </div>
      <div className=''>
        <div
          className='absolute top-0 right-0 flex-shrink-0  lg:w-[3px] lg:h-[523px] 2xl:w-[4px] 2xl:h-[705px] 3xl:w-[8px] right-[14.5px] 3xl:h-[1000px] 2xl:right-[26.8px] lg:right-[20px]
          3xl:right-[37px]
          bg-[linear-gradient(90deg,_#3DC3D8_0%,_#24547C_100%)] hidden lg:block'
        ></div>
        <div className='relative  shrink-0 lg:w-[402.886px] lg:h-[365.785px] 2xl:w-[543.801px] 2xl:h-[493.724px] 3xl:w-[742.999px] 3xl:h-[674.578px] lg:mt-[40px] 2xl:mt-[103px] hidden lg:block'>
          <div
            className='shrink-0 rounded-[40px] bg-[#0C5F71] ] lg:w-[313.531px] 
            lg:h-[313.531px] 2xl:w-[423.192px] 2xl:h-[423.192px] 3xl:w-[578.21px] 3xl:h-[578.21px] box-border
            absolute top-0 3xl:left-[89.62px]  2xl:left-[65.6px] 2xl:[70.53px] lg:left-[48.6px] z-10
            hidden lg:block
            '
          ></div>
          <div className='shrink-0 rounded-[40px] border-[2px] border-[#8DD8EB]  lg:w-[313.531px] lg:h-[313.531px] 2xl:w-[423.192px] 2xl:h-[423.192px] 3xl:w-[578.21px] 3xl:h-[578.21px] absolute right-0 3xl:top-[50.11px] 2xl:top-[36.68px] lg:top-[27.17px] z-30 hidden lg:block'></div>

          <img
            src={ourMison}
            className='absolute bottom-0 left-0    lg:w-[313.531px] lg:h-[313.531px] 2xl:w-[423.192px] 2xl:h-[423.192px] 3xl:w-[578.21px] 3xl:h-[578.21px] z-20 hidden lg:block '
          />
        </div>
        <button
          className='hidden lg:flex justify-center items-center shrink-0 h-8 px-[12px] py-1.5 rounded-[6px] text-white text-center text-base font-medium leading-5 tracking-wide bg-[#020251] shadow-[0px_1px_4px_rgba(0,0,0,0.25)] lg:w-[200px] lg:h-8  2xl:w-[240px] 2xl:h-11 2xl:px-4 2xl:py-3 2xl:rounded-lg
    3xl:w-[340px] 3xl:h-11 lg:mt-[70px] lg:ml-[150px] 2xl:mt-[60px] 2xl:ml-[250px] 3xl:ml-[328px] 3xl:mt-[160px] hover:text-[#65C2D7] '
          onClick={() => navigate('/find-a-lawyer/search')}
        >
          Get help today
        </button>

        <div className='relative w-[329px] h-[285px] lg:w-[359px] lg:h-[343px] 2xl:w-[493px] 2xl:h-[457px] 3xl:w-[682px] 3xl:h-[554px] mt-5 lg:mt-30 2xl:mt-40 3xl:mt-[216px]'>
          <div className='absolute right-0 top-0 inline-flex p-4 flex-col justify-center items-start rounded-xl border border-[0.6px] border-[#9FCDD7] [background:linear-gradient(245deg,_rgba(159,_205,_215,_0.20)_3.28%,_rgba(224,_250,_255,_0.20)_91.79%)] [backdrop-filter:blur(100px)] z-20'>
            <p
              className='text-center font-medium text-sm leading-normal  lg:font-medium 2xl:text-lg 2xl:leading-6 2xl:font-bold 3xl:text-2xl 3xl:leading-8'
              style={{
                background: 'linear-gradient(90deg, #009DAF 0%, #12315A 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                color: 'transparent',
              }}
            >
              The right lawyer, every time.
            </p>
          </div>
          <OurValues />
        </div>
      </div>
    </div>
  )
}
export default OurMissionHeader
